import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import {
  FILE_NAME_WITHOUT_DOUBLE_QUOTES_REGEXP,
  FILE_NAME_WITH_DOUBLE_QUOTES_REGEXP
} from 'src/utils/constants'

import { showInfoModal } from '../helpers/dialogs'

export const getFileName = (content = '', fileNameDefault = '') => {
  const firstCheck = content.match(FILE_NAME_WITH_DOUBLE_QUOTES_REGEXP)
  let fileName = fileNameDefault

  if (firstCheck && firstCheck?.[0]) {
    fileName = firstCheck?.[0]
  } else {
    const secondCheck = content.match(FILE_NAME_WITHOUT_DOUBLE_QUOTES_REGEXP)

    if (secondCheck && secondCheck?.[0]) {
      fileName = secondCheck?.[0]
    }
  }

  return fileName
}

const exportReport = async (config = {}, fileNameDefault = '') => {
  try {
    const { data, headers, status } = await httpClient.request({
      method: 'get',
      url: config,
      isDownload: true
    })
    if (status === 202) {
      showInfoModal({
        content:
          'Activity log report has been added to the queue for processing. You will receive an email with the exported data.'
      })
      return
    }
    const content = headers['content-disposition']
    const fileName = getFileName(content, fileNameDefault)
    const link = document.createElement('a')

    link.setAttribute('href', window.URL.createObjectURL(new Blob([data])))
    link.setAttribute('download', fileName)

    document.body.appendChild(link)

    link.click()
  } catch (error: any) {
    catchError(error)
  }
}

export default exportReport
